import React, { FC, useState } from "react";
import { LoadingAnimation } from "../LoadingAnimation/LoadingAnimation";

interface SearchInputProps {
  query: string;
  placeholder: string;
  searchUrl: string;
  loading: boolean;
}

export const SearchInput: FC<SearchInputProps> = ({
  query,
  placeholder,
  searchUrl,
  loading,
}) => {
  const [value, setValue] = useState(query);

  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key == "Enter") {
      submit();
    }
  };

  const submit = () => {
    window.location.href = `${searchUrl}?q=${value}`;
  };

  return (
    <div className="input-group mb-2 mb-md-4">
      <input
        className={"form-control form-control-fullwidth mb-0"}
        placeholder={placeholder}
        type="search"
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={(e) => onKeyDown(e)}
        value={value}
        disabled={loading}
      />
      <button
        className={"btn btn-primary search-result-page-btn"}
        onClick={() => submit()}
        disabled={loading}
      >
        {loading ? <LoadingAnimation text={"Søk"} /> : "Søk"}
      </button>
    </div>
  );
};
